module.exports = __webpack_public_path__ + "static/media/36.5c4cba81.jpg";